// Requisiti del cliente e indirizzi di consegna [sc-48860].
// Stesse regole di barcio-api src/utils/cliente.js.

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Parole che compaiono nei domini dei gestori PEC (pec.it, legalmail.it,
// arubapec.it, postacert.it, cert.<ordine>.it). Servono solo a un avviso che
// non blocca: i gestori sono tanti e un elenco chiuso rifiuterebbe PEC vere.
const DOMINI_PEC = /(pec|legalmail|postacert|cert)/i;

/** Formato nome@dominio.tld, per email e PEC. */
export function emailValida(value) {
  return EMAIL_RE.test(String(value ?? "").trim());
}

/** PEC valida nel formato ma con un dominio che non sembra di un gestore PEC. */
export function pecSospetta(value) {
  const pec = String(value ?? "").trim();
  if (!emailValida(pec)) return false;
  return !DOMINI_PEC.test(pec.split("@")[1]);
}

const OBBLIGATORI = [
  ["clientName", "Nome cliente"],
  ["taxCode", "Codice fiscale"],
  ["phoneNumber", "Telefono"],
];

/** Etichette dei campi obbligatori ancora vuoti: nome, codice fiscale, telefono. */
export function obbligatoriCliente(formData) {
  return OBBLIGATORI.filter(
    ([campo]) => !String(formData?.[campo] ?? "").trim()
  ).map(([, etichetta]) => etichetta);
}

const ultimoPreventivo = (c) => {
  const t = Date.parse(c?.lastQuote);
  return Number.isFinite(t) ? t : -Infinity;
};

/**
 * Clienti da proporre nella ricerca del preventivo [sc-48892]: prima quelli
 * con il preventivo più recente (senza preventivi in fondo), poi per nome.
 * A campo vuoto sono i primi della lista, così al click compare già qualcosa.
 */
export function clientiPerRicerca(clienti, testo = "", limite = 10) {
  const q = String(testo || "")
    .toLowerCase()
    .trim();
  const ordinati = [...(clienti || [])].sort(
    (a, b) =>
      ultimoPreventivo(b) - ultimoPreventivo(a) ||
      String(a.clientName || "").localeCompare(String(b.clientName || ""), "it")
  );
  const trovati = q
    ? ordinati.filter((c) =>
        String(c.clientName || "")
          .toLowerCase()
          .includes(q)
      )
    : ordinati;
  return trovati.slice(0, limite);
}

const asLoc = (raw) => {
  if (!raw) return null;
  if (typeof raw !== "string") return raw;
  try {
    return JSON.parse(raw);
  } catch {
    return { address: raw };
  }
};

/** Indirizzi del cliente da proporre come consegna, solo quelli compilati. */
export function indirizziDiConsegna(cliente) {
  if (!cliente) return [];
  return [
    ["Residenza", cliente.residenceAddress],
    ["Cantiere", cliente.worksiteAddress],
  ]
    .map(([etichetta, raw]) => ({
      etichetta,
      address: (asLoc(raw)?.address || "").trim(),
    }))
    .filter((v) => v.address);
}

/**
 * Indirizzi del blocco "Dettaglio cliente" del PDF: la sede legale sempre
 * (N/D se vuota, come prima), residenza e cantiere solo se compilati.
 * Le colonne JSONB arrivano gia' come oggetto: `asLoc` regge anche la stringa.
 */
export function indirizziPerPdf(cliente) {
  const sede = (asLoc(cliente?.legalHeadquarters)?.address || "").trim();
  return [
    { etichetta: "sede legale", address: sede || undefined },
    ...indirizziDiConsegna(cliente).map((v) => ({
      etichetta: v.etichetta.toLowerCase(),
      address: v.address,
    })),
  ];
}
